import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import canteenReducer from "../features/canteen/canteenSlices";
import locationReducer from "../features/location/locationSlice";
import surveyReducer from "../features/survey/surveySlice";
import mySurveysReducer from "../features/mySurveys/mySurveysSlice";
import languageReducer from "../features/language/languageSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    canteen: canteenReducer,
    location: locationReducer,
    survey: surveyReducer,
    mySurveys: mySurveysReducer,
    language: languageReducer,
  },
});

